exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-223863d8]{background-color:#FFFFFF;max-height:80%;max-width:100%;display:flex;flex-direction:column}.sprint-chart[data-v-223863d8]{width:100%;height:35vh;margin-top:20px;flex-grow:3}.sprint-dash[data-v-223863d8]{width:100%;height:30vh;padding-right:32px;padding-left:32px;display:flex;flex-grow:1;flex-direction:column}.hour-divider[data-v-223863d8]{margin-top:auto}\n", ""]);

// exports
